$ = require 'jquery'
WarningBannerView = require 'app/scripts/views/header/warning-banner-view'
Auth = require 'app/scripts/db/auth'
template = require 'app/scripts/views/templates/header_enterprise_deprovisioning'
{ track } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'

module.exports = class EnterpriseDeprovisioningBannerView extends WarningBannerView
  className: Util.extendParentClassName('enterprise-deprovisioning-banner')

  events:
    'click .js-dismiss-enterprise-deprovisioning-banner': 'dismiss'

  render: ->
    data =
      enterpriseName: @model.displayName
      enterpriseStanding: @model.enterpriseStanding
      pendingDeprovision: @model.pendingDeprovision
    @$el.html template(data)

    @

  dismiss: (e) ->
    track("Header", "Enterprise Deprovisioning Banner", "Dismiss")
    Auth.me().dismissEnterpriseDeprovisioningBannerFor @model.idEnterprise
    $(e.target).closest('.enterprise-deprovisioning-banner').remove()
    e.preventDefault()
